import { spacer24 } from '@spotify-internal/encore-web';
import styled from 'styled-components';

export const LoadingIndicatorWrapper = styled.div`
  text-align: center;
  margin-top: ${spacer24};
`;
